export default __webpack_public_path__ + "static/highlight-3-4fabe0a9e4d55cfcd0adf0c9f5298c48.svg";